import { render, staticRenderFns } from "./AppEchartBar.vue?vue&type=template&id=1991bf97&scoped=true&"
import script from "./AppEchartBar.vue?vue&type=script&lang=js&"
export * from "./AppEchartBar.vue?vue&type=script&lang=js&"
import style0 from "./AppEchartBar.vue?vue&type=style&index=0&id=1991bf97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991bf97",
  null
  
)

export default component.exports